import { NposCreateResponse } from '../types/npos';
import { LoginResponse } from '../types/register';
import { GeneratedLink, UserInfo, userSettingsResponse } from '../types/user';
import { Api } from './Api';

export class UserService {
    
    public static getMeInfo = async () : Promise<UserInfo> => {
        let target = ``;
        await Api.baseUrlGenerator(`base`).then( envResponse => {
            target = `${envResponse}/me`;
        });
        return Api.get(target);
    }

    public static postRefresh = async (): Promise<LoginResponse> => {
        let target = ``;
        await Api.baseUrlGenerator(`base`).then( envResponse => {
            target = `${envResponse}/refresh`;
        });
        return Api.post(target, {});
    }

    public static generateLink = async (name:string, fee:number): Promise<GeneratedLink> => {
        let target = ``;
        await Api.baseUrlGenerator(`client`).then( envResponse => {
            target = `${envResponse}/nposInvite`;
        });

        const payload = {npos_name:name, unit_fee:fee}
        return Api.post(target, payload);
    }

    public static createNposStation = async (token:string): Promise<NposCreateResponse> => {
        let target = ``;
        await Api.baseUrlGenerator(`base`).then( envResponse => {
            target = `${envResponse}/toctoc?invite=${token}`;
        });
        return Api.get(target);
    }

    public static changeUserSettings = async (payload:any, ): Promise<any> => {
        let target = ``;
        await Api.baseUrlGenerator(`base`).then( envResponse => {
            target = `${envResponse}/settings`;
        });
        return Api.post(target, payload);
    }

    public static getUserSettings = async (): Promise<userSettingsResponse> => {
        let target = ``;
        await Api.baseUrlGenerator(`base`).then( envResponse => {
            target = `${envResponse}/settings`;
        });
        return Api.get(target);
    }

    // NPOS
    // All Functions related to User/NPOS Info
    public static fetchNposList = async (): Promise<any> => {
        let target = ``;
        await Api.baseUrlGenerator(`client`).then( envResponse => {
            target = `${envResponse}/listNpos`;
        });
        return Api.get(target);
    }
    public static invalidateNposList = async (npos_id:string): Promise<any> => {
        let target = ``;
        await Api.baseUrlGenerator(`client`).then( envResponse => {
            target = `${envResponse}/invalidateNpos`;
        });
        const payload = {
            npos_id
        }
        return Api.post(target, payload);
    }

    public static getNposList = async () : Promise<any> => {
        let target = ``;
        await Api.baseUrlGenerator(`base`).then( envResponse => {
            target = `${envResponse}/userNposNameTags`;
        });

        return Api.get(target);
    }

    public static getNposInfo = async () : Promise<UserInfo> => {
        let target = ``;
        await Api.baseUrlGenerator(`base`).then( envResponse => {
            target = `${envResponse}/me`;
        });
        return Api.get(target);
    }

    public static getNposSettings = async () : Promise<userSettingsResponse> => {
        let target = ``;
        await Api.baseUrlGenerator(`base`).then( envResponse => {
            target = `${envResponse}/settings`;
        });
        return Api.get(target);
    }

}